@use '../../styles/colors';

$permission-background-color-variable-name: --ixf-permission-background;

.permission {
  &:not(:last-child) {
    border-bottom: 1px solid var(--ixf-color-separator);
  }

  &.hideSeparator {
    border-bottom: none;
  }

  &.notInEffect {
    .icon {
      opacity: 0.6;
    }
  }

  &.isPending {
    .icon {
      background: none;

      &::before {
        display: none;
      }
    }
  }

  .listContainer {
    padding: 0 var(--ixf-space-6);
  }

  .booleanContainer {
    padding: 15px 0;
  }

  .suffix {
    margin-left: auto;
  }

  .iconLoading {
    width: 16px;
    height: 16px;
  }

  .nameLoading {
    height: 0.875rem;
  }

  .icon {
    position: relative;
    background: var(--ixf-color-background);
    border-radius: 50%;

    // Default variant is for "false" value
    color: var(--ixf-color-danger-dk);

    @include colors.define-best-supported-color-value(
      $permission-background-color-variable-name,
      color(from var(--ixf-color-danger-md) srgb r g b / 0.2),
      color(from var(--ixf-color-danger-md) display-p3 r g b / 0.2),
    );

    &.isActive {
      // Active variant is for "true" value
      color: var(--ixf-color-green-dk);

      @include colors.define-best-supported-color-value(
        $permission-background-color-variable-name,
        color(from var(--ixf-color-green-md) srgb r g b / 0.2),
        color(from var(--ixf-color-green-md) display-p3 r g b / 0.2),
      );
    }

    > * {
      z-index: 1;
    }

    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background: var(#{$permission-background-color-variable-name});
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
